module.exports = __webpack_public_path__ + "src/assets/img/page8/b343bf849d880182e5968b570b4b2d6f.jpg";